export const dateFormat = 'YYYY-MM-DD';
export const iconColor = 'rgba(0,0,0,.25)';
